import React, { Component } from "react"
import icon from '../images/icone-analysis-document.png';

export class RegistrationAnalysis extends Component {

  render() {
    return (
      <div className="container h-100" >
        <div className="row text-center px-4 mt-5" style={{minHeight: 'calc(100vh - 106px)'}}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5 " >
            <img src={icon} style={{maxHeight: '105px'}} alt="" className="img-fluid mx-auto d-block mt-4"/>
            <h1 className="card-title fw-bold text-white mt-5">PROCESSANDO O DOCUMENTO</h1>
            <div className="row mt-5 justify-content-center">
              <div className="col-12 d-grid">
                <main className="position-relative">
                 <div className="loading-bar-container ">
                   <div className=" loading-bar-container loading-bar" />
                 </div>
                 <h5 className="position-absolute start-50 translate-middle mt-4">Aguarde...</h5>
               </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RegistrationAnalysis;
